import { useFormik } from 'formik';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Select from 'react-select';
import { Button, Card, CardBody, Container, Form, FormGroup, Label } from 'reactstrap';
import { InputField } from 'src/components';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import { actionColumnStyles, dataTableCustomStyles } from 'src/components/Common/FixedActionColumn';
import { useGetCourseApplicantionListQuery } from 'src/rtk/features/courseApproval/courseApprovalApi';
import { useLazyGetCourseApprovalListExcelQuery } from 'src/rtk/features/exportExcel/exportExcel';
import { useGetLookupDataQuery } from 'src/rtk/features/setup/lookup/lookupDataApi';
import { useGetOrganizationsQuery } from 'src/rtk/features/setup/organization/setupOrganizationApi';
import { useGetSubjectInfosQuery } from 'src/rtk/features/setup/subjectInfo/subjectInfoApi';
import { useGetSupervisorsByInstituteQuery } from 'src/rtk/features/trainingRecord/trainingRecordlApi';
import loader from '../../assets/images/loader.gif';
import CourseApprovalViewModal from './CourseApprovalViewModal';
import ProfileViewModal from './ProfileViewModal';
import SlotApprovalViewModal from './SlotApprovalViewModal';

const CourseApprovalList = () => {
    const [modalShow, setModalShow] = useState(false);
    const [courseInfoModal, setCourseInfoModal] = useState(false);
    const [slotInfoModal, setSlotInfoModal] = useState(false);
    const [approvalId, setApprovalId] = useState('');
    const [selectedSubject, setSelectedSubject] = useState<any>('');
    const [selectedInstitue, setSelectedInstitute] = useState<any>('');
    const [selectedSupervisor, setSelectedSupervisor] = useState<any>('');

    const [selectedInstitueCategory, setSelectedInstituteCategory] = useState<any>('');
    const [selectedTraineeCategory, setSelectedTraineeCategory] = useState<any>('');
    const [selectedIncomeCategory, setSelectedIncomeCategory] = useState<any>('');

    let referenceUrl = new URLSearchParams(location.search).get('ref');

    const { data: subjects } = useGetSubjectInfosQuery();

    const { data: supervisors } = useGetSupervisorsByInstituteQuery(selectedInstitue ? selectedInstitue.value : '');

    const [getCourseApprovalListExcel, { isLoading: isExcelLoading, isFetching: isExcelFetching }] = useLazyGetCourseApprovalListExcelQuery();

    const allSupervisors: SelectOption[] =
        supervisors?.data?.map((item) => ({
            value: item.user_id!,
            label: item.full_name!,
        })) || [];

    const allSubjects: SelectOption[] =
        subjects?.data?.map((subject) => ({
            value: subject.subject_name,
            label: subject.subject_name,
        })) || [];

    const { data: sessionLookupData } = useGetLookupDataQuery('session');

    const sessionList: SelectOption[] =
        (sessionLookupData as any)?.data[0]?.childs?.map((item: any) => ({
            value: item.name,
            label: item.name,
        })) || [];

    const currentYear = new Date().getFullYear();
    const startYear = 2025;

    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
        years.push(year);
    }

    const allYears: SelectOption[] = years?.map((item: any) => ({
        value: item,
        label: item,
    })) || [];

    const courseSession: SelectOption[] = [
        { value: 'January-June', label: 'January-June' },
        { value: 'July-December', label: 'July-December' },
    ];

    const instituteList: SelectOption[] =
        useGetOrganizationsQuery()
            .data?.data?.map((item) => ({
                value: item.id!,
                label: item.organization_name!,
            }))
            .sort((a, b) => {
                return a.label.localeCompare(b.label);
            }) || [];

    const allStatus: SelectOption[] = [
        { value: 'Approve', label: 'Approve' },
        { value: 'Pending', label: 'Pending' },
        { value: 'Reject', label: 'Reject' },
    ];

    const allTrainingInstituteCategory: SelectOption[] = [
        { label: 'Sadar Hospital/District Hospital/Zila Hospital', value: 'Sadar Hospital/District Hospital/Zila Hospital' },
        { label: 'Government Medical College Hospital (under MoHFW)', value: 'Government Medical College Hospital (under MoHFW)' },
        { label: 'Public Medical University', value: 'Public Medical University' },
        { label: 'Government Postgraduate Medical Institute (under MoHFW)', value: 'Government Postgraduate Medical Institute (under MoHFW)' },
        { label: 'Government Institute/Hospital (under MoHFW)', value: 'Government Institute/Hospital (under MoHFW)' },
        { label: 'Government Institute/Hospital (under Ministry of Defence)', value: 'Government Institute/Hospital (under Ministry of Defence)' },
        { label: 'Govermnent Institute/Hospital (under Ministry of Home Affairs)', value: 'Govermnent Institute/Hospital (under Ministry of Home Affairs)' },
        { label: 'Government Hospital (under Ministry of public Administration)', value: 'Government Hospital (under Ministry of public Administration)' },
        { label: 'Non-Government Postgraduate Medical Institute/Hospital', value: 'Non-Government Postgraduate Medical Institute/Hospital' },
        { label: 'Non-Governmnet Charitable Organization', value: 'Non-Governmnet Charitable Organization' },
        { label: 'Private Medical College Hospital', value: 'Private Medical College Hospital' },
        { label: 'Private Hospital', value: 'Private Hospital' },
        { label: 'Foreign Institute/Hospital', value: 'Foreign Institute/Hospital' },
    ];

    const allTraineeCategory: SelectOption[] = [
        { label: 'Trainees receiving allowances in government institutions', value: 'Trainees receiving allowances in government institutions' },
        { label: 'Trainees receiving allowances by private institutions', value: 'Trainees receiving allowances by private institutions' },
        { label: 'Trainees in government employment', value: 'Trainees in government employment' },
        { label: 'Trainees in private employment', value: 'Trainees in private employment' },
    ];

    const allIncomeCategory: SelectOption[] = [
        { label: 'Yes, involvement in Job/Income generating activities', value: 'Yes' },
        { label: 'No, not involvement in Job/Income generating activities', value: 'No' },
    ];

    const [page, setPage] = useState<any>(1);
    const [limit, setLimit] = useState<any>(10);
    const [search, setSearch] = useState('');

    const generateQueryUrl = () => {
        return `page=${page}&per_page=${limit}${search}`;
    };

    const handlePageChange = (page: number) => {
        setPage(page);
    };

    const handlePerRowsChange = (newPerPage: number, page: number) => {
        setLimit(newPerPage);
        setPage(page);
    };

    const {
        data: approvalList,
        isSuccess,
        isLoading,
        isFetching,
        refetch,
    } = useGetCourseApplicantionListQuery(generateQueryUrl());

    useEffect(() => {
        refetch();
    }, [referenceUrl]);

    interface SearchFields {
        search?: string;
        start_date?: string;
        end_date?: string;
        approved_status?: string;
        supervisors_approve_status?: string;
        bmdc_registration_no?: string;
        fcps_part_one_passing_session?: string;
        fcps_part_one_passing_year?: string;
        institute_id?: string;
        subject?: string;
        training_institute_type?: string;
        trainee_category?: string;
        income_category?: string;
        session_name?: string;
        session_year?: string;
        supervisor_id?: string;
    }

    const initialValues: SearchFields = {
        search: '',
        start_date: '',
        end_date: '',
        approved_status: '',
        supervisors_approve_status: '',
        bmdc_registration_no: '',
        fcps_part_one_passing_session: '',
        fcps_part_one_passing_year: '',
        institute_id: '',
        subject: '',
        training_institute_type: '',
        trainee_category: '',
        income_category: '',
        session_name: '',
        session_year: '',
        supervisor_id: '',
    };

    const {
        handleSubmit,
        getFieldProps,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        resetForm,
        setFieldValue,
        setErrors,
    } = useFormik({
        initialValues,

        onSubmit: (values: any) => {
            let s: string = '';

            if (values.search !== '') {
                s = s + `&search=${values.search}`;
            }

            if (values.start_date !== '') {
                s = s + `&start_date=${values.start_date}`;
            }

            if (values.end_date !== '') {
                s = s + `&end_date=${values.end_date}`;
            }

            if (values.approved_status !== '') {
                s = s + `&approved_status=${values.approved_status}`;
            }

            if (values.supervisors_approve_status !== '') {
                s = s + `&supervisors_approve_status=${values.supervisors_approve_status}`;
            }

            if (values.bmdc_registration_no !== '') {
                s = s + `&bmdc_registration_no=${values.bmdc_registration_no}`;
            }
            if (values.fcps_part_one_passing_session !== '') {
                s = s + `&fcps_part_one_passing_session=${values.fcps_part_one_passing_session}`;
            }
            if (values.fcps_part_one_passing_year !== '') {
                s = s + `&fcps_part_one_passing_year=${values.fcps_part_one_passing_year}`;
            }
            if (values.subject !== '') {
                s = s + `&subject=${values.subject}`;
            }
            if (values.institute_id !== '') {
                s = s + `&institute_id=${values.institute_id}`;
            }

            if (values.training_institute_type !== '') {
                s = s + `&training_institute_type=${values.training_institute_type}`;
            }
            if (values.trainee_category !== '') {
                s = s + `&trainee_category=${values.trainee_category}`;
            }
            if (values.income_category !== '') {
                s = s + `&income_category=${values.income_category}`;
            }

            if (values.session_name !== '') {
                s = s + `&session_name=${values.session_name}`;
            }
            if (values.session_year !== '') {
                s = s + `&session_year=${values.session_year}`;
            }
            if (values.supervisor_id !== '') {
                s = s + `&supervisor_id=${values.supervisor_id}`;
            }

            setSearch(s);
            setPage('1');
            console.log(values);
        },
    });

    const columns: TableColumn<any>[] = [
        {
            name: <div>Sl. No.</div>,
            width: '60px',
            cell: (row, index) => <strong>{((page - 1) * limit + index) + 1}</strong>,
        },
        {
            name: <div>Apply Date</div>,
            width: '110px',
            selector: (row) => row?.created_at,
            cell: (row, index) =>
                row.created_at ? moment(row?.created_at).format('DD-MMM-YYYY') : '',
        },

        {
            name: <div>Full Name</div>,
            width: '140px',
            selector: (row) => row?.profile_info?.personal_info?.full_name,
            wrap: true,
        },

        {
            name: <div>BMDC Reg. No.</div>,
            selector: (row) => row?.profile_info?.bmdc_registration_no,
            wrap: true,
        },
        {
            name: <div>Reg. Type</div>,
            selector: (row) => row?.profile_info?.registration_type,
            wrap: true,
        },

        {
            name: <div>Course Name</div>,
            width: '110px',
            selector: (row) => row?.exam_name,
            wrap: true,
        },

        {
            name: <div>Passing Session & Year</div>,
            width: '110px',
            selector: (row) => row?.profile_info?.fcps_part_one_passing_session ? row?.profile_info?.fcps_part_one_passing_session + ' - ' + row?.profile_info?.fcps_part_one_passing_year : 'N/A',
            wrap: true,
        },

        {
            name: <div>Institute</div>,
            width: '180px',
            selector: (row) =>
                row?.profile_info?.unapproved_current_session_and_supervisor_info?.supervisor?.institute_name ?? 'N/A',
            wrap: true,
        },

        {
            name: <div>Subject</div>,
            width: '110px',
            selector: (row) => row?.subject_name,
            wrap: true,
        },

        {
            name: <div>Current Session</div>,
            width: '110px',
            selector: (row) => row?.profile_info?.unapproved_current_session_and_supervisor_info?.session_name,
            wrap: true,
        },

        {
            name: <div>Supervisor</div>,
            width: '130px',
            selector: (row) => row?.profile_info?.unapproved_current_session_and_supervisor_info?.supervisor?.name,
            wrap: true,
        },

        {
            name: <div>Supervisor Approval Status</div>,
            width: '110px',
            selector: (row) => row?.supervisors_approve_status,
            cell: (row) => {
                switch (row?.supervisors_approve_status) {
                    case 'Reject':
                        return (
                            <>
                                <div className="badge rounded-pill d-inline-block badge-rejected font-size-12 fw-medium">
                                    {'Rejected'}
                                </div>
                            </>
                        );

                    case 'Draft':
                        return (
                            <>
                                <div className="badge rounded-pill d-inline-block badge-draft font-size-12 fw-medium">
                                    {row?.supervisors_approve_status}
                                </div>
                            </>
                        );

                    case 'Approve':
                        return (
                            <>
                                <div className="badge rounded-pill d-inline-block badge-approved font-size-12 fw-medium">
                                    {'Approved'}
                                </div>
                            </>
                        );

                    case 'Pending':
                        return (
                            <>
                                <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                                    {row?.supervisors_approve_status}
                                </div>
                            </>
                        );

                    default:
                        return (
                            <>
                                <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                                    {row?.supervisors_approve_status}
                                </div>
                            </>
                        );
                }
            },
            wrap: true,
        },
        {
            name: <div>Admin Approval Status</div>,
            selector: (row) => row?.admin_approval_status,
            width: '140px',
            cell: (row) => {
                switch (row?.admin_approval_status) {
                    case 'Reject':
                        return (
                            <>
                                <div className="badge rounded-pill d-inline-block badge-rejected font-size-12 fw-medium">
                                    {'Rejected'}
                                </div>
                            </>
                        );

                    case 'Draft':
                        return (
                            <>
                                <div className="badge rounded-pill d-inline-block badge-draft font-size-12 fw-medium">
                                    {row?.admin_approval_status}
                                </div>
                            </>
                        );

                    case 'Approve':
                        return (
                            <>
                                <div className="badge rounded-pill d-inline-block badge-approved font-size-12 fw-medium">
                                    {'Approved'}
                                </div>
                            </>
                        );

                    case 'Pending':
                        return (
                            <>
                                <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                                    {row?.admin_approval_status}
                                </div>
                            </>
                        );

                    default:
                        return (
                            <>
                                <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                                    {row?.admin_approval_status}
                                </div>
                            </>
                        );
                }
            },
        },
        {
            name: <div>Action</div>,
            style: actionColumnStyles,
            width: '240px',
            cell: (row, index) => (
                <div className='d-flex gap-1 my-1'>
                    <Button
                        className="btn btn-sm btn-info"
                        onClick={() => modalShowHandler(true, row?.id)}
                    >
                        Profile
                    </Button>

                    <Button
                        className="btn btn-sm btn-success"
                        onClick={() => courseModalShowHandler(true, row?.id)}
                    >
                        Course
                    </Button>

                    <Button
                        className="btn btn-sm btn-warning"
                        onClick={() => slotModalShowHandler(true, row?.id)}
                        // disabled={row?.supervisors_approve_status !== 'Approve'}
                    >
                        Slot
                    </Button>
                    {modalShow && approvalId === row?.id ? (
                        <ProfileViewModal
                            isOpen={modalShow}
                            toggle={() => setModalShow(!modalShow)}
                            info={row}
                            id={row.registration_id!}
                        />
                    ) : null}

                    {courseInfoModal && approvalId === row?.id ? (
                        <CourseApprovalViewModal
                            isOpen={courseInfoModal}
                            toggle={() => setCourseInfoModal(!courseInfoModal)}
                            info={row}
                            id={row.registration_id!}
                        />
                    ) : null}

                    {slotInfoModal && approvalId === row?.id ? (
                        <SlotApprovalViewModal
                            isOpen={slotInfoModal}
                            toggle={() => setSlotInfoModal(!slotInfoModal)}
                            info={row}
                            id={row.registration_id!}
                        />
                    ) : null}
                </div>
            ),
        },
    ];

    const modalShowHandler = (modalState: boolean, id: string) => {
        setModalShow(modalState);
        setApprovalId(id);
    }

    const courseModalShowHandler = (modalState: boolean, id: string) => {
        setCourseInfoModal(modalState);
        setApprovalId(id);
    }

    const slotModalShowHandler = (modalState: boolean, id: string) => {
        setSlotInfoModal(modalState);
        setApprovalId(id);
    }

    useEffect(() => {
        if (selectedSubject !== '') {
            setFieldValue('subject', selectedSubject?.value);
        }
    }, [selectedSubject]);

    useEffect(() => {
        if (selectedInstitue !== '') {
            setFieldValue('institute_id', selectedInstitue?.value);
        }
    }, [selectedInstitue]);


    useEffect(() => {
        if (selectedInstitueCategory !== '') {
            setFieldValue('training_institute_type', selectedInstitueCategory?.value);
        }
    }, [selectedInstitueCategory]);

    useEffect(() => {
        if (selectedTraineeCategory !== '') {
            setFieldValue('trainee_category', selectedTraineeCategory?.value);
        }
    }, [selectedTraineeCategory]);

    useEffect(() => {
        if (selectedIncomeCategory !== '') {
            setFieldValue('income_category', selectedIncomeCategory?.value);
        }
    }, [selectedIncomeCategory]);

    useEffect(() => {
        if (selectedSupervisor !== '') {
            setFieldValue('supervisor_id', selectedSupervisor?.value);
        }
    }, [selectedSupervisor]);

    const tableHeadersCSV = ["Sl. No.", "Current Session", "Name", "BMDC", "Mobile", "Speciality", "Institute", "Year of Passing Part-1", "Supervisor", "Institute Category", "Trainee Category", "Involvement in Income"];

    const handleExport = async () => {
        try {
            const csvText = await getCourseApprovalListExcel(search).unwrap();
            const blob = new Blob([csvText], {
                type: 'text/csv;charset=utf-8;',
            });

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');

            a.href = url;
            a.download = `Course_Applicant_List_${Date.now()}.csv`;
            document.body.appendChild(a);
            a.click();

            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Export failed', err);
        }
    };

    return (
        <div className="page-content">
            {isFetching || isLoading || isExcelLoading ? (
                <div className="overlay">
                    <img src={loader} alt="Loading" height={100} width={300} />
                </div>
            ) : null}
            <Container fluid>
                <BetterBreadcrumb
                    breadcrumbItem={[{ link: '#', name: 'Admin' }]}
                    title={'Course Application Approval'}
                />
                <Card>
                    <CardBody>
                        <Form
                            className="custom-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                            onReset={(e) => {
                                e.preventDefault();
                                handleSubmit();
                                setSelectedSubject('');
                                setSelectedInstitute('');
                                setSelectedInstituteCategory('');
                                setSelectedTraineeCategory('');
                                setSelectedIncomeCategory('');
                                setSelectedSupervisor('');
                                resetForm();
                            }}
                        >
                            <div className="filter-wrapper">
                                <FormGroup>
                                    <Label for="bmdc_registration_no">BMDC Reg. No</Label>
                                    <InputField
                                        type="text"
                                        placeholder="BMDC Reg. No"
                                        {...getFieldProps('bmdc_registration_no')}
                                    />
                                </FormGroup>


                                <FormGroup>
                                    <Label for="start_date">From Date</Label>
                                    <InputField
                                        type="date"
                                        {...getFieldProps('start_date')}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="end_date">To Date</Label>
                                    <InputField
                                        type="date"
                                        {...getFieldProps('end_date')}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="subject">Subject</Label>
                                    <Select
                                        isClearable={true}
                                        isSearchable={true}
                                        value={selectedSubject}
                                        onChange={setSelectedSubject}
                                        options={allSubjects}
                                        placeholder='Select...'
                                        name="subject"
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="fcps_part_one_passing_session">Passing Session</Label>
                                    <InputField
                                        type="select"
                                        placeholder="Passing Session"
                                        options={sessionList}
                                        {...getFieldProps('fcps_part_one_passing_session')}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="fcps_part_one_passing_year">Passing Year</Label>
                                    <InputField
                                        type="select"
                                        placeholder="Passing Year"
                                        options={allYears}
                                        {...getFieldProps('fcps_part_one_passing_year')}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="institute_name">Institute</Label>
                                    <Select
                                        isClearable={true}
                                        isSearchable={true}
                                        value={selectedInstitue}
                                        onChange={setSelectedInstitute}
                                        options={instituteList}
                                        placeholder='Institute'
                                        name="institute_name"
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="supervisor_id" className="form-label">Supervisor</Label>
                                    <Select
                                        isClearable={true}
                                        isSearchable={true}
                                        value={selectedSupervisor}
                                        onChange={setSelectedSupervisor}
                                        options={allSupervisors}
                                        placeholder='Select...'
                                        name="supervisor_id"
                                    />

                                </FormGroup>

                                <FormGroup>
                                    <Label className="form-label">Institute Category</Label>
                                    <Select
                                        isClearable={true}
                                        isSearchable={true}
                                        value={selectedInstitueCategory}
                                        onChange={setSelectedInstituteCategory}
                                        options={allTrainingInstituteCategory}
                                        placeholder='Select...'
                                        name="training_institute_type"
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label className="form-label">Trainee Category</Label>
                                    <Select
                                        isClearable={true}
                                        isSearchable={true}
                                        value={selectedTraineeCategory}
                                        onChange={setSelectedTraineeCategory}
                                        options={allTraineeCategory}
                                        placeholder='Select...'
                                        name="trainee_category"
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label className="form-label">Income Category</Label>
                                    <Select
                                        isClearable={true}
                                        isSearchable={true}
                                        value={selectedIncomeCategory}
                                        onChange={setSelectedIncomeCategory}
                                        options={allIncomeCategory}
                                        placeholder='Select...'
                                        name="income_category"
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="session_name">Session Name</Label>
                                    <InputField
                                        type="select"
                                        placeholder="Session Name"
                                        options={courseSession}
                                        {...getFieldProps('session_name')}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="session_year">Session Year</Label>
                                    <InputField
                                        type="select"
                                        placeholder="Session Year"
                                        options={allYears}
                                        {...getFieldProps('session_year')}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="supervisors_approve_status">Supervisor Approval Status</Label>
                                    <InputField
                                        type="select"
                                        placeholder="Status"
                                        options={allStatus}
                                        {...getFieldProps('supervisors_approve_status')}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="approved_status">Admin Approval Status</Label>
                                    <InputField
                                        type="select"
                                        placeholder="Status"
                                        options={allStatus}
                                        {...getFieldProps('approved_status')}
                                    />
                                </FormGroup>

                                <FormGroup className="btn-column mb-3">
                                    <Button color="danger" type="reset" >Reset</Button>
                                    <Button type="submit" color='primary'>Search</Button>
                                </FormGroup>

                                <FormGroup className='d-flex justify-content-end'>
                                    {/* <CSVLink
                                        headers={tableHeadersCSV}
                                        data={approvalList?.data?.data?.map((data: any, index: number) => [
                                            ((page - 1) * limit + index) + 1,
                                            data?.profile_info?.current_session_and_supervisor_info?.session_name,
                                            data?.profile_info?.personal_info?.full_name,
                                            data?.profile_info?.bmdc_registration_no,
                                            data?.profile_info?.mobile,
                                            data?.subject_name,
                                            data?.profile_info?.current_session_and_supervisor_info?.supervisor?.institute_name ?? 'N/A',
                                            data?.profile_info?.fcps_part_one_passing_session ? data?.profile_info?.fcps_part_one_passing_session + ' - ' + data?.profile_info?.fcps_part_one_passing_year : 'N/A',
                                            data?.profile_info?.current_session_and_supervisor_info?.supervisor?.name,
                                            data?.profile_info?.current_session_and_supervisor_info?.training_institute_type,
                                            data?.profile_info?.current_session_and_supervisor_info?.trainee_category,
                                            data?.profile_info?.current_session_and_supervisor_info?.income_category,
                                        ]) || []}
                                        filename="TraineeList.csv"
                                    >
                                        <Button type="button" color='success' outline className='fw-bold'>
                                            <i className="fa-solid fa-file-arrow-down"></i>{' '}
                                            Export
                                        </Button>
                                    </CSVLink> */}
                                    <Button
                                        type="button"
                                        color="success"
                                        outline
                                        className="fw-bold"
                                        onClick={handleExport}
                                    >
                                        <i className="fa-solid fa-file-arrow-down"></i>{' '}
                                        Export CSV
                                    </Button>
                                </FormGroup>
                            </div>
                        </Form>

                        <DataTable
                            columns={columns}
                            data={approvalList?.data?.data!}
                            customStyles={dataTableCustomStyles}
                            pagination
                            paginationServer
                            progressPending={isLoading}
                            expandOnRowClicked
                            highlightOnHover
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handlePerRowsChange}
                            paginationTotalRows={approvalList?.data?.total}
                            paginationRowsPerPageOptions={[10, 20, 50, 100, 500, 1000, 2000, 5000]}
                            responsive
                            persistTableHead={true}
                        />
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default CourseApprovalList;
